import React from 'react';
import "./Common.css";
import Header from "../Components/Header";
import { FaCircleCheck } from "react-icons/fa6";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom"; //Link

export default function ThankYou() {
  return (
    <div>
        <Header mode="dark" />

            <div className='container'>
        <div className='thankyou-outer'>
            <div className='thank-pg'>
               <FaCircleCheck />
                <h1>Thank you for your purchase.</h1>
                <p>Your payment has been completed successfully and your order is confirmed.</p>
                <div className='btn-back-home'>
                     <Link to="/">Back To Shopping</Link>
                </div>
            </div>
        </div>
    </div>

        <Feature />
        <Footer />
    </div>
  )
}
